module.exports = __webpack_public_path__ + "static/media/Ditto_gaussian2.e2508249.png";